'use client';

import { useQuery } from '@tanstack/react-query';
import type { TransferTarget } from '../types/calls.types';

async function fetchAvailableStaff(): Promise<TransferTarget[]> {
  const res = await fetch('/api/v1/staff/available');
  const json = await res.json();
  if (!res.ok) return [];
  return (json.data ?? []) as TransferTarget[];
}

export function useAvailableStaff(enabled = true) {
  return useQuery<TransferTarget[]>({
    queryKey: ['staff', 'available'],
    queryFn: fetchAvailableStaff,
    enabled,
    staleTime: 30_000,
  });
}
